 
 
class QuantityCart extends HTMLElement {
  constructor() {
    super()
    this.input = null
    this.requestInFlight = false
    this.onButtonClick = this.onButtonClick.bind(this)
  }

  connectedCallback() {
    if (this.dataset.quantityReady === 'true') return
    this.input = this.querySelector('input')
    if (!this.input) return
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick))
    this.dataset.quantityReady = 'true'
  }

  disconnectedCallback() {
  }

  onButtonClick(event) {
    event.preventDefault()
    event.stopImmediatePropagation()
    if (!this.input || this.requestInFlight) return
    const previousValue = this.input.value
    event.currentTarget.name === "plus" ? this.input.stepUp() : this.input.stepDown()
    if (previousValue === this.input.value) return
    this.updateCart(Number(this.input.value), previousValue)
  }

  updateCart(quantity, previousValue) {
    const itemKey = this.input.dataset.line
    const row = this.input.closest('.responsive-table-row')
    const lineNumber = row && row.parentElement
      ? Array.from(row.parentElement.children).indexOf(row) + 1
      : null
    const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/'
    this.requestInFlight = true
    this.setAttribute('aria-busy', 'true')
    this.querySelectorAll('button').forEach((button) => { button.disabled = true })

    fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(lineNumber
        ? { line: lineNumber, quantity: quantity }
        : { id: itemKey, quantity: quantity })
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart update failed')
        return response.json()
      })
      .then((cart) => {
        this.renderCart(cart, itemKey)
        if (quantity === 0 || cart.item_count === 0) window.location.reload()
      })
      .catch(() => {
        this.input.value = previousValue
      })
      .finally(() => {
        this.requestInFlight = false
        this.removeAttribute('aria-busy')
        this.querySelectorAll('button').forEach((button) => { button.disabled = false })
      })
  }

  renderCart(cart, line) {
    const item = cart.items.find((cartItem) => cartItem.key === line)
    if (item) {
      document.querySelectorAll('input[data-line="' + CSS.escape(line) + '"]').forEach((input) => {
        input.value = item.quantity
      })
      document.querySelectorAll('.pn-total-line-item[data-id="' + CSS.escape(line) + '"]').forEach((element) => {
        if (!element.querySelector('.pn-total-line-item')) element.textContent = formatPrice(item.final_line_price)
      })
    }

    document.querySelectorAll('.header_user_cart > span').forEach((counter) => {
      counter.textContent = cart.item_count
      counter.hidden = cart.item_count === 0
    })
    const subtotal = document.querySelector('.w-subtotal span')
    if (subtotal) subtotal.textContent = formatPrice(cart.total_price)
  }
}

if (!customElements.get("quantity-input")) customElements.define("quantity-input", QuantityCart)




function cng_product_item(id,productHandle){
const formEl = document.getElementById('product_form_'+id);
  if (!formEl) return;
  const select = formEl.querySelector('select[name="id"]');  
  if (select) { 
  const selectedOption = select.options[select.selectedIndex];  
  if (selectedOption) {
    const inventory = selectedOption.getAttribute('data-inventory'); 
    const buy_btn = formEl.querySelector('.buy-btn');
    if (inventory<=0) { 
        buy_btn.disabled = true;
        buy_btn.textContent = 'Sold Out';
    } else {
        buy_btn.disabled = false;
        buy_btn.textContent = 'Add to cart';
    }
  }
}


  const blockElement=document.getElementById("item_"+productHandle);
  if (!blockElement) return;
  const selectElement = blockElement.querySelector('select');
  const variantId = parseInt(selectElement.value);
  const priceElement=blockElement.querySelector('.product_item_price');  

  fetch(`/products/${productHandle}.js`)
  .then(response => response.json())
  .then(product => { 
      const variant = product.variants.find(v => v.id === variantId); 
      const compare_at_price=parseInt(variant.compare_at_price);
      const price=parseInt(variant.price);
      let html='';
      if (compare_at_price>price) {
        html='<span class=money data-compare-price >'+formatPrice(compare_at_price)+'</span><span class="money" data-product-price>'+formatPrice(price)+'</span>';
        if (window.theme.show_save_price === true) {
          const difference = (price*100)/compare_at_price;
          let percentageDifference =100- difference; 
         percentageDifference=Math.ceil(percentageDifference);
         if (percentageDifference<11) {
          let cng_price=compare_at_price-price; 
          html += '<span class="percentage_difference">SAVE '+formatPrice(cng_price)+'</span>'; 
         } else {
          html += '<span class="percentage_difference">SAVE '+percentageDifference+'%</span>'; 
         }
        }
      } else {
        html='<span class=money data-compare-price ></span><span class="money" data-product-price>'+formatPrice(price)+'</span>';
      } 
      priceElement.innerHTML=html;
      
  })
  .catch(error => console.error('Error:', error));


}

function formatPrice(price) { 
  const formattedPrice = (price / 100).toFixed(2);
  return '$'+formattedPrice;
}






jQuery(document).ready(function () { 


  jQuery('.faq-item-title').on('click',function(){ 
    if(!$(this).hasClass('active'))
    {
        jQuery(this).next().slideDown();
        jQuery('.faq-item-title.active').next().stop().slideUp();
        jQuery('.faq-item-title.active').removeClass('active');
        jQuery(this).addClass('active');
    }
    else
    {
        jQuery(this).removeClass('active');
        jQuery(this).next().stop().slideUp();
    }
});

  })


  
  const rating_button = document.querySelector('.data-oke-star-rating');
  if (rating_button) rating_button.addEventListener('click', () => {
    const targetDiv = document.querySelector('.product_reviews'); 
    if (targetDiv) targetDiv.scrollIntoView({ behavior: 'smooth' });
});

 
   

  if (document.querySelector('.product_slider')) {
    var product_slider_thumb = new Swiper('.product_slider_thumb', {
      direction: 'vertical',
      slidesPerView: 'auto',
      spaceBetween: 10,
      loop: false,
      rewind: true,
      speed: 500,
      slideToClickedSlide: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      freeMode: true,
      breakpoints: {
        0: { spaceBetween: 8 },
        769: { spaceBetween: 10 }
      }
    });

    var product_slider = new Swiper('.product_slider', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      rewind: true,
      allowTouchMove: true,
      touchStartPreventDefault: false,
      speed: 600,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        clickable: true
      },
      thumbs: {
        swiper: product_slider_thumb
      }
    });

    document.querySelectorAll('.product_slider_thumb .swiper-slide').forEach(function (thumbnail, index) {
      thumbnail.setAttribute('role', 'button');
      thumbnail.setAttribute('tabindex', '0');
      thumbnail.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        product_slider.slideTo(index);
      });
    });
  }


jQuery(document).ready(function ($) {
  var $header = jQuery('#shopify-section-header')
  var lastScrollTop = 0

  function onScroll() {
    var scrollTop = jQuery(window).scrollTop()

    if (scrollTop > lastScrollTop && scrollTop > 34) {
      $header.addClass('is-scroll')
    } else if (scrollTop <= 0) {
      $header.removeClass('is-scroll')
    }
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop
  }

  jQuery(window).on('load', onScroll)
  jQuery(window).on('scroll', onScroll)
})


function show_tr(id) {
  if ($('#title_tr_'+id).hasClass('active')) {
    $('#title_tr_'+id).removeClass('active')
    $('#tr_'+id).removeClass('active')
  } else {
    $('#title_tr_'+id).addClass('active')
    $('#tr_'+id).addClass('active')
  }
}

function best_collections(nom) {
  const namesBlock = document.querySelector('.best-collections__names'); 
 
  namesBlock?.querySelectorAll('span').forEach(el =>
    el.classList.remove('active')
  );
 
document
    .querySelectorAll('.best-collections__items')
    .forEach(el => el.classList.remove('active'));
 
  document
    .getElementById(`best_collections_title_${nom}`)
    ?.classList.add('active');
 
  document
    .getElementById(`best_collections_item_${nom}`)
    ?.classList.add('active');
}


function services(name) {
  const namesBlock = document.querySelector('.services__items_titles'); 
  console.log(`services_${name}`);
 
  namesBlock?.querySelectorAll('span').forEach(el =>
    el.classList.remove('active')
  );
 
document
    .querySelectorAll('.services__items_wrapp')
    .forEach(el => el.classList.remove('active'));
 
  document
    .getElementById(`services_title_${name}`)
    ?.classList.add('active');
 
  document
    .querySelectorAll(`.services_${name}`)
    .forEach(el => el.classList.add('active'));
}
  function decreaseQuantity(button) { 
    const input = button.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;

    let value = parseInt(input.value, 10) || 1;
    value = Math.max(1, value - 1); 
    input.value = value;
}

function increaseQuantity(button) {
    const input = button.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;

    let value = parseInt(input.value, 10) || 1;
    input.value = value + 1;
}
